import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Home from '../pages/Home';
import AboutUs from '../pages/AboutUs'; 
import ContactUs from '../pages/ContactUs';
import ApplyNow from '../components/apply-now';
// import ApplyNow from '../pages/ApplyNow.js';
// import ApplyForLoan from '../components/apply-for-loan';
import TermsAndConditions from '../components/terms&conditions';
import PrivacyPolicy from '../components/privacy-policy'; 
import CorporateGovernancePage from '../pages/CorporateGovernancePage';
import FairPracticeCodePage from '../pages/FairPracticeCodePage';
import KycAndPmlaPage from '../pages/KycAndPmlaPage';
import RiskManagementPolicyComponent from '../components/risk-management-policy';
import TermsRatesComponent from '../components/terms-rates';
import Faqs from '../components/faqs'; 
// import GrievanceRedressal from '../components/grievance-redressal';
// import Career from '../pages/Career';
import InterestRatePolicy from '../components/interest-rate-policy';
import RepayLoan from '../pages/RepayLoan';
import RepayLoan1 from '../pages/RepayLoan1';
import PaymentSuccess from '../pages/PaymentSuccess';
import KeyFactStatement from '../components/key-fact-statement';
import Check from '../components/check';
import GetPanVerify from '../components/getpanverify';
import VideoKYC from '../components/video-kyc';
import Blog from '../components/blog';
import BlogDetails from '../components/blog-details';
// import LendingPartner from '../components/lending-partner';
// import LandingPage from '../pages/LandingPage';
// import ApplyAadhaarFlow from "../components/ApplyNowSteps/ApplyAadhaarFlow";
// import ThankYou from "../components/ApplyNowSteps/ThankYou";


const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/contact-us" element={<ContactUs />} />
         <Route path= "/apply-now" element={<ApplyNow />} />
      <Route path="/terms-conditions" element={<TermsAndConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/corporate-governance" element={<CorporateGovernancePage />} />
      <Route path="/fair-practice-code" element={<FairPracticeCodePage />} />
      <Route path="/interest-rate-policy" element={<InterestRatePolicy />} />
      <Route path="/kyc-and-pmla" element={<KycAndPmlaPage />} />
      <Route path="/risk-management-policy" element={<RiskManagementPolicyComponent />} />
      <Route path="/terms-rates" element={<TermsRatesComponent />} />
      <Route path="/faqs" element={<Faqs />} />
      {/* <Route path="/grievance-redressal" element={<GrievanceRedressal />} /> */}
      {/* <Route path="/career" element={<Career />} /> */}
      <Route path="/repay-loan" element={<RepayLoan />} />
      <Route path="/repay-loan1" element={<RepayLoan1 />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/key-fact-statement" element={<KeyFactStatement />} />
      {/* <Route path="/apply-now" element={<ApplyForLoan />} /> */}
          <Route path='/check' element={<Check />} />
      {/* <Route path="/thank-you" element={<ThankYou />} /> */}
      {/* <Route path="/aadhaar-verify" element={<ApplyAadhaarFlow />} /> */}
      <Route path='/getpanverify' element={<GetPanVerify />} />
      <Route path='/video-kyc' element={<VideoKYC />} />
      <Route path="/blogs" element={<Blog />} />
      <Route path="/blog-details/:id" element={<BlogDetails />} />
      {/* <Route path="/lending-partner" element={<LendingPartner />} /> */}
      {/* <Route path="/landing" element={<LandingPage />} /> */}
      <Route path="*" element={<div><h2>404 - Page Not Found</h2></div>} />
    </Routes>
  );
};

export default AppRoutes;
